// extracted by mini-css-extract-plugin
module.exports = {"form":"Form_form__2xX6V","form-field":"Form_form-field__1PWcF","checkbox":"Form_checkbox__I8JbE"};